import { Rest, baseUrl } from '../../../lib/rest'
import * as util from '../../auth/components/util'

const projectsUrl = `${baseUrl}/projects/v1`
const surveyQaUrl = `${baseUrl}/feedback/v1`
const attrubutesUrl = `${baseUrl}/data/v1/attributes`
const lineitemsUrl = `${baseUrl}/lineitems/v1/get`
const questionnaireUrl = `${baseUrl}/questionnaire/v1`
const historyUrl = `${baseUrl}/history/v1`

export function loadProject(projectUUID, lineItemUUID) {
  return dispatch => {    
    dispatch(commenceFetch())
    return Rest.get(`${projectsUrl}/${projectUUID}/${lineItemUUID}`)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { project: data }
            dispatch(onFetchProjectSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function loadLineitemsByProjectId(request) {
  return dispatch => {    
    dispatch(commenceFetch())
    return Rest.get(lineitemsUrl, request)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = data
            dispatch(onFetchLineitemsByProjectIdSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function loadSurveyQaInfo(lineItemUUID) {
  return dispatch => {    
    return Rest.get(`${surveyQaUrl}/${lineItemUUID}`)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { attributes: data }
            dispatch(onFetchAttributesSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function saveSurveyQa(lineItemUUID, type, request) {
  return dispatch => {    
    return Rest.post(`${surveyQaUrl}/${lineItemUUID}/${type}`, request)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            dispatch(onSaveSurveyQaSuccess(res))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function getAttributesDetails(country, language, id) {
  return dispatch => {    
    return Rest.get(`${attrubutesUrl}/${country}/${language}`, id)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { attributesDetails: data }
            dispatch(onFetchAttributeDetailsSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function loadSurveyQuestionnaire() {
  return dispatch => {    
    return Rest.get(`${questionnaireUrl}`)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { questionnaire: data.surveyData }
            dispatch(onFetchQuestionnaireSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function loadHistory(lineItemUUID) {
  return dispatch => {    
    return Rest.get(`${historyUrl}/${lineItemUUID}`)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { lineItemHistory: data }
            dispatch(onFetchHistorySuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function reset() {
  return dispatch => {
    dispatch(resetError())
  }
}

function commenceFetch() {
  return {
    type: "PROJECT_COMMENCE_FETCH"
  }
}

function onFetchProjectSuccess(payload) {
  return {
    type: "PROJECT_DID_LOAD",
    payload
  }
}

function onFetchAttributesSuccess(payload) {
  return {
    type: "ATTRIBUTES_DID_LOAD",
    payload
  }
}

function onSaveSurveyQaSuccess(payload) {
  return {
    type: "SURVEY_QA_SAVED",
    payload
  }
}

function onFetchAttributeDetailsSuccess(payload) {
  return {
    type: "ATTRIBUTES_DETAILS_DID_LOAD",
    payload
  }
}

function resetError() {
  return {
    type: "PROJECT_RESET_ERROR"
  }
}

function onFetchLineitemsByProjectIdSuccess(payload) {
  return {
    type: "LINEITEMS_BY_PROJECTID",
    payload
  }
}

function onFetchQuestionnaireSuccess(payload) {
  return {
    type: "QUESTIONNAIRE_DID_LOAD",
    payload
  }
}

function onFetchHistorySuccess(payload) {
  return {
    type: "HISTORY_DID_LOAD",
    payload
  }
}